import { render, staticRenderFns } from "./CustomInputSelect.vue?vue&type=template&id=b604563a&lang=pug&"
import script from "./CustomInputSelect.vue?vue&type=script&lang=js&"
export * from "./CustomInputSelect.vue?vue&type=script&lang=js&"
import style0 from "./CustomInputSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports